import { useSelector } from "react-redux";

export const useBurger = () => {
  const { isOpen } = useSelector((state) => state.app.burger);

  return {
    isOpen,
  };
};
